import { render } from "./CIS-Content-One-Column.vue?vue&type=template&id=6c8c248e&scoped=true"
import script from "./CIS-Content-One-Column.vue?vue&type=script&lang=js"
export * from "./CIS-Content-One-Column.vue?vue&type=script&lang=js"

import "./CIS-Content-One-Column.vue?vue&type=style&index=0&id=6c8c248e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c8c248e"]])

export default __exports__